import { ApiService, toModel } from '~/shared/api'
import { VacancyModel } from '~/models/vacancy'

export class VacanciesDetailService extends ApiService {
  readonly urls = {
    vacancy: '/api/v1/yavagro/vacancy',
  }

  getDetailVacancyPage(id: number | string): Promise<VacancyModel> {
    return this.http.request({ url: `${this.urls.vacancy}/${id}` }).then(toModel(VacancyModel))
  }
}
